<template>
  <div class="app-text">

    <input-title :required="options.required" :description="options.description"/>

    <div class="input-groups">

      <div
        v-for="(_, i) in valueLocal"
        :key="`input-group-${i}`"
        class="input-group"
        @click="removeError(i)">

        <div class="input-group-title required" :class="{ required: options.required }"
             v-html="'Место работы №' + (i + 1) + (!i ? ' (основное)' : '')"/>

        <div class="input-group-item">
          <el-select
            v-model="valueLocal[i].organizationId"
            :key="`organization-id-${i}`"
            :class="{ 'child-has-error': error[i] && valueLocal[i].organizationId !== 'other' }"
            filterable
            clearable
            placeholder="Выберите организацию"
            style="width: 100%;"
            @focus="removeError(i)"
            @input="onOrganizationIdChanged(i)"
            v-bind="widgetOptions">
            <el-option
              v-for="(o, j) in organizations"
              :key="`organization-id-option-${j}`"
              :label="o.label"
              :value="o.value">
            </el-option>
          </el-select>
        </div>

        <div class="input-group-item">
          <template v-if="valueLocal[i].organizationId === 'other'">
            <div class="input-subtitle required" :class="{ required: options.required }">
              Название организации</div>
            <el-input
              v-model="valueLocal[i].organization"
              :class="{ 'child-has-error': error[i] }"
              :key="`organization-${i}`"/>
          </template>
        </div>

        <div class="input-group-item">
          <div class="input-subtitle required">Название подразделения</div>
          <el-input
            v-model="valueLocal[i].department"
            :key="`department-${i}`"/>
        </div>

        <div class="input-group-item">
          <div class="input-subtitle">Должность</div>
          <el-input
            v-model="valueLocal[i].post"
            :key="`post-${i}`"/>
        </div>

        <div class="input-group-item">
          <div class="input-subtitle">
            Дата начала работы (год или точная дата)</div>

          <div class="row">
            <div class="col">

              <el-select
                v-model="valueLocal[i].dateFromType"
                style="width: 100%"
                :key="'date-from-type-' + i">
                <el-option
                  v-for="(label, key, i) in { date: 'Точная дата', year: 'Год' }"
                  :key="`date-from-type-option-${i}`"
                  :label="label"
                  :value="key">
                </el-option>
              </el-select>

            </div>
            <div class="col">

              <el-date-picker
                v-model="valueLocal[i].dateFrom"
                :type="valueLocal[i].dateFromType"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd"
                placeholder="Выберите">
              </el-date-picker>

            </div>
          </div>

        </div><!-- /.input-group-item -->

        <div class="input-group-item">

          <div class="input-subtitle">Дата окончания работы</div>

          <div class="row">
            <div class="col" :class="{ 'full': valueLocal[i].dateToType === 'today' }">

              <el-select
                v-model="valueLocal[i].dateToType"
                :key="`date-to-type-${i}`">
                <el-option
                  v-for="(label, key, i) in
                    { today: 'По настоящее время', date: 'Точная дата', year: 'Год' }"
                  :key="`date-to-type-option-${i}`"
                  :label="label"
                  :value="key">
                </el-option>
              </el-select>

            </div>
            <div class="col" v-if="valueLocal[i].dateToType !== 'today'">

              <div v-if="['date', 'year'].indexOf(valueLocal[i].dateToType) > -1">
                <el-date-picker
                  v-model="valueLocal[i].dateTo"
                  :type="['date', 'year'].indexOf(valueLocal[i].dateToType) > -1
                    ? valueLocal[i].dateToType : 'date'"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  placeholder="Выберите">
                </el-date-picker>
              </div>

            </div>
          </div>

        </div><!-- /.input-group-item -->

        <div v-if="error[i]" class="ait_message ait_message--error">{{ error[i] }}</div>

      </div>

    </div>

    <add-rem-btns/>

  </div>
</template>

<script>
import axios from 'axios';
import Common from './mixins/Common';

export default {

  mixins: [Common],

  data() {
    return {
      valueBase: {
        organizationId: '',
        organization: '',
        department: '',
        post: '',
        dateFromType: 'date',
        dateFrom: '',
        dateToType: 'today',
        dateTo: '',
      },
      errorBase: '',
      organizations: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },

  created() {
    // Add error messages
    this.validateMessages = Object.assign(
      { noOrganization: 'Укажите место работы!' }, this.validateMessages);

    // Get organizations list
    axios.get('organizations').then((res) => {
      res.data.forEach((el) => {
        const OrganizationId = el.OrganizationId;
        const Organization = el.Name;
        this.organizations.push({
          value: OrganizationId,
          label: Organization,
        });
      });
      this.organizations.unshift({
        value: 'other',
        label: 'Другая организация',
      });
    });
  },

  methods: {

    setValue(value) {
      this.valueLocal.pop();

      value.forEach((job) => {
        const j = {};
        if (job.OrganizationId) {
          j.organizationId = job.OrganizationId;
        } else if (job.Organization) {
          j.organizationId = 'other';
        }
        j.organization = job.Organization;
        j.department = job.Department;
        j.post = job.Post;
        j.dateFrom = job.StartDate;
        j.dateFromType = 'date';
        if (j.dateFrom) {
          if (j.dateFrom.match(/^\d{4}-\d{2}-\d{2}$/)) {
            j.dateFromType = 'date';
          } else {
            j.dateFromType = 'year';
          }
        }
        j.dateTo = job.EndDate;
        j.dateToType = 'today';
        if (j.dateTo) {
          if (j.dateTo === '+') {
            j.dateToType = 'today';
          } else if (j.dateTo.match(/^\d{4}-\d{2}-\d{2}$/)) {
            j.dateToType = 'date';
          } else {
            j.dateToType = 'year';
          }
        }
        this.valueLocal.push(j);
      });

      this.updateValue();
    },

    getError() {
      // Validate required
      if (this.options.required) {
        this.valueLocal.forEach((value, i) => {
          if (!value.organizationId
            || (value.organizationId === 'other' && !value.organization)
          ) {
            this.error[i] = this.validateMessages.noOrganization;
          }
        });
      }
      this.updateError();
      return this.error;
    },

    onOrganizationIdChanged(i) {
      const orgId = this.valueLocal[i].organizationId;
      if (orgId === 'other') {
        this.valueLocal[i].organization = '';
      } else {
        this.organizations.forEach((orgData) => {
          if (orgData.value === orgId) {
            this.valueLocal[i].organization = orgData.label;
          }
        });
      }
    },

  },

};
</script>

<style lang="scss" scoped>
.row {
  margin: -5px;
  .col {
    width: 50%;
    float: left;
    padding: 5px;
    &.full {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/inputs/widgets/AppJob.vue